module.exports = __webpack_public_path__ + "static/img/5i.fa93ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5i.jpg
// module id = Eys6
// module chunks = 0